import {
  Button,
  CircularProgress,
  Search,
} from "@totalenergiescode/mobility-business-rev-design-system";
import type { TFunction } from "i18next";

import {
  StyledGetTemplateButtonContainer,
  StyledInputContainer,
} from "../styles";

type GetTemplateButtonProps = {
  tFormData: TFunction<"formData">;
  canFetchCreationTemplate: boolean;
  isCreationTemplateLoading: boolean;
  onFetchCreationTemplate: () => void;
};

export const GetTemplateButton = ({
  tFormData,
  canFetchCreationTemplate,
  isCreationTemplateLoading,
  onFetchCreationTemplate,
}: GetTemplateButtonProps) => (
  <StyledInputContainer>
    <StyledGetTemplateButtonContainer>
      <Button
        variant='primary'
        size='s'
        isLowercase
        disabled={!canFetchCreationTemplate}
        leftIcon={
          isCreationTemplateLoading ? (
            <CircularProgress size={16} color='inherit' />
          ) : (
            <Search width={16} height={16} color='white' />
          )
        }
        buttonText={tFormData("formData.creationTemplate.buttons.getTemplate")}
        onClick={() => {
          onFetchCreationTemplate();
        }}
      />
    </StyledGetTemplateButtonContainer>
  </StyledInputContainer>
);
